import React from 'react';
import { ButtonTertiary } from "../ButtonTertiary/index.js";
import { IconX } from "../Icon/icons/IconX/index.js";
import styled from "../../styled-components.js";
import { cssSpacing } from "../../styles/layout-theme.js";
var CloseButtonStyled = styled(ButtonTertiary).withConfig({
  displayName: "CloseButton__CloseButtonStyled",
  componentId: "sc-1n0japy-0"
})(["margin:calc(-1 * ", ");"], cssSpacing('tighter'));
export var CloseButton = function CloseButton(props) {
  return /*#__PURE__*/React.createElement(CloseButtonStyled, {
    iconOnly: IconX,
    "aria-label": props.closeButtonAriaLabel,
    onClick: props.onClose,
    type: "button"
  });
};